import { Link, useHistory, withRouter } from 'react-router-dom';
import { useQuery } from 'react-query';
import { useState } from 'react';
import * as api from 'actions';
import { Images } from 'assets/Images';
import './style.scss';
import Cookies from 'js-cookie';

const SideBar = () => {
    const { REACT_APP_GEOLOCATION } = process.env;
    const [roleActive, setRoleActive] = useState(false);
    const permissions = api.decrypting(localStorage.getItem('access-list'));
    const roles = api.decrypting(localStorage.getItem('_ro'));
    const roleList = roles ? JSON.parse(roles) : [];
    let activeRole = api.decrypting(localStorage.getItem('_sro')) || (roleList?.length > 0 && roleList[0]?.name);
    const activeUserPermissions = permissions ? JSON?.parse(permissions)?.map(role => role?.RoleName) : [];
    const history = useHistory();
    const deviceId = "deviceID";
    let resObj;

    const { refetch: refetchLogout } = useQuery(['logout', ''], () => api.logout(), {
        enabled: false,
        onSuccess: () => {
            if (REACT_APP_GEOLOCATION && localStorage.getItem('co_lat') && localStorage.getItem('co_lon')) {
                            resObj = {
                                lat: localStorage.getItem('co_lat'),
                                lng: localStorage.getItem('co_lon'),
                                application : "APPROVAL_PORTAL",
                                device : Cookies.get(deviceId) 
                            }
                            refetchLogoutTime();
                        } else {
                localStorage.clear();
                history.push({ pathname: '/' });
            }
        }
    });
     
    const { refetch: refetchLogoutTime } = useQuery(['logout' , resObj], () => api.logoutTime(resObj), {
        enabled: false,
        onSuccess: () => {
            localStorage.clear();
            history.push({ pathname: '/' });
        }
    });

    // logout API call
    const handleLogout = () => {
        refetchLogout();
    }

    const handleOpenUser = (event, user) => {
        event.stopPropagation();
        setRoleActive(!roleActive);
    };

    const handleChangeRole = (event, item) => {
        event.stopPropagation();
        const clickedUserPermissions = roleList?.find(role => role?.id === item?.id)?.permissions;
        activeRole = item?.name;
        const prKeys = Object.keys(clickedUserPermissions).map(el => ({ RoleName: el, applicationId: 'APPROVAL_PORTAL', permissions: '' }));
        const result = prKeys.map(el => Object.assign({ ...el, permissions: clickedUserPermissions[el.RoleName] }));
        localStorage.setItem('access-list', api.encrypting(JSON.stringify(result)));
        localStorage.setItem('_sro', api.encrypting(item?.name));
        if (result?.length > 0 && result[0]?.RoleName) {
            getNavUrl(result[0]?.RoleName);
        } else {
            refetchLogout();
        }
        // eslint-disable-next-line no-restricted-globals
        location.reload();
        setRoleActive(false);
    };

    const getNavUrl = (name) => {
        switch (name) {
            case 'workflow_maintenance':
                history.push({ pathname: '/workflow-maintenance' });
                break;
            case 'exception_maintenance':
                history.push({ pathname: '/exception-maintenance' });
                break;
            case 'matrix_maintenance':
                history.push({ pathname: '/matrix-maintenance' });
                break;
            default:
                refetchLogout();
                break;
        }
    }

    const removeUnderscore = (text) => text.replace(/_/g, " ");

    const firstTwoChar = (text) => {
        const split = text.split(' ');
        return split.length > 1 ? split[0][0] + split[1][0] : split[0]?.substring(0, 2).toUpperCase();
    };

    return (
        <>
            <aside className="side-bar">
                <div className="logo"> <img src={Images.logo} alt="approval" /></div>
                <div className="logo-auth" onClick={(e) => handleOpenUser(e, "user")}>
                    {(localStorage.getItem('username') || '').charAt(0)}
                    {activeRole && (
                        <span>
                            {firstTwoChar(removeUnderscore(activeRole))}
                            <samp>{removeUnderscore(activeRole)}</samp>
                        </span>
                    )}
                    <div className={`role-list ${roleActive ? "is-active" : "is-normal"}`}>
                        <ul>
                            {roleList.map((item, index) => (
                                <li key={index} onClick={(e) => handleChangeRole(e, item)}>
                                    {item?.name}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <nav>
                    <ul>
                        {activeUserPermissions?.includes('workflow_maintenance') &&
                            <li>
                                <Link to={{ pathname: "/workflow-maintenance" }}><img src={Images.workflow} alt='workflow' />
                                    <span>Workflow</span>
                                </Link>
                            </li>
                        }
                        {activeUserPermissions?.includes('exception_maintenance') &&
                            <li>
                                <Link to={{ pathname: "/exception-maintenance" }} ><img src={Images.condition} alt='exception' />
                                    <span>Exception</span>
                                </Link>
                            </li>
                        }
                        {activeUserPermissions?.includes('matrix_maintenance') &&
                            <li>
                                <Link to={{ pathname: "/matrix-maintenance" }} ><img src={Images.matrix} alt='matrix' />
                                    <span>Matrix</span>
                                </Link>
                            </li>
                        }
                        <li onClick={handleLogout}>
                            <img src={Images.logout} alt='logout' />
                            <span>Logout</span>
                        </li>
                    </ul>
                </nav>
            </aside >
        </>

    )
}

export default withRouter(SideBar);

